export type MultiServiceAddonPayloadItem = {
  service_id: string;
  addon_id: string;
  quantity: number;
};

/**
 * Builds the JSON payload expected by `create_multi_service_booking_public`.
 *
 * Input map format:
 * - addonQtyByServiceId[serviceId][addonId] = quantity
 */
export function buildMultiServiceAddonPayload(args: {
  serviceIds: string[];
  addonQtyByServiceId: Record<string, Record<string, number | string | null | undefined> | undefined>;
}): MultiServiceAddonPayloadItem[] {
  const out: MultiServiceAddonPayloadItem[] = [];
  const serviceIds = Array.isArray(args.serviceIds) ? args.serviceIds : [];
  const m = args.addonQtyByServiceId || {};

  for (const sid of serviceIds) {
    if (!sid) continue;
    const qtyMap = m[sid] || {};
    for (const [addonId, rawQty] of Object.entries(qtyMap)) {
      if (!addonId) continue;
      const n = Number(rawQty || 0);
      if (!Number.isFinite(n) || n <= 0) continue;
      out.push({ service_id: sid, addon_id: addonId, quantity: Math.floor(n) });
    }
  }

  return out;
}

